<template>
  <div class="hospital-layout-footer">
    <div class="copyright">
      <div>
        京ICP备16042301号
        <br />
      </div>
      <div style="margin-top:18px;">Copyright © 2015-{{ new Date().getFullYear() }}北京荣之联科技股份有限公司版权所有 </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.hospital-layout-footer {
  width: 100%;
  padding: 16px 0;
  .copyright {
    text-align: center;
    width: 1200px;
    margin: 0 auto;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 16px;
    letter-spacing: 1px;
    color: #818489;
  }
}
</style>
